









import Vue from 'vue';
import { IFooterPaymentTypesComponent } from '../../../common/interfaces/footer.interface';
import { EPaymentTypes } from '../../../common/enums/footer.enum';
import PaymentLogo from './PaymentLogo.vue';

export default Vue.extend({
  name: `PaymentTypes`,
  components: { PaymentLogo },
  data(): IFooterPaymentTypesComponent {
    return {
      EPaymentTypes,
    };
  },
});
